module.exports = __webpack_public_path__ + "static/media/img-10.e685b1a1.jpg";